angular.module('unica_media_upload.media_services', []);